import { ViewModel,View, Component } from "binder"
import { getAsBoolean } from "../utilities";
import  { ToggleButtonView } from "./toggleButton-view"

export class ToggleButtonViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.isselected = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new ToggleButtonView();
    }
    public getTypeId(): string {
        return "VM-3943AF80-5049-489D-9F6F-F5A61C6E801E"
    }
    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;
    public set isselected(v: boolean) { this._isselected = getAsBoolean(v); } public get isselected(): boolean { return this._isselected;} private _isselected: boolean;
    
    click() {
        this.isselected = !this.isselected;
    }
    
}
